/* tslint:disable */
/* eslint-disable */
/**
 * LogQS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Statement } from "./Statement";
import {
  StatementFromJSON,
  StatementFromJSONTyped,
  StatementToJSON,
} from "./Statement";

export interface PolicyInput {
  statement: Array<Statement>;
}

export function PolicyInputFromJSON(json: any): PolicyInput {
  return PolicyInputFromJSONTyped(json);
}

export function PolicyInputFromJSONTyped(json: any): PolicyInput {
  if (json == null) {
    return json;
  }

  return {
    statement: (json["statement"] as Array<any>).map(StatementFromJSON),
  };
}

export function PolicyInputToJSON(value: PolicyInput | null | undefined): any {
  if (value == null) {
    return value;
  }

  return {
    statement: (value.statement as Array<any>).map(StatementToJSON),
  };
}
